<template>
  <Container
    class="
      mt-10 w-full
      print:hidden
    "
  >
    <nav>
      <ul class="flex auto-cols-auto flex-wrap gap-x-2 gap-y-3">
        <DesktopNavigationCollapseLevel1
          v-for="(level1NavItem) in globals?.main.tree"
          :key="level1NavItem.page.id"
          :nav-item="level1NavItem"
        />
      </ul>
    </nav>
  </Container>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey)
</script>
